export default "__VITE_ASSET__BzDSXwhd__"